import { atom } from "jotai";

import { contactApi } from "../services";
import type { ContactOption } from "../types";

export const contactsAtom = atom<ContactOption[]>([]);

export const contactsLoadingAtom = atom(false);

/**
 * The whole address book, read once and kept: it changes far more slowly than
 * a form is opened, and the combobox filters it itself. A form that shows the
 * person it named reads their name from here too.
 */
export const loadContactsAtom = atom(null, async (get, set): Promise<void> => {
  if (get(contactsLoadingAtom) || 0 < get(contactsAtom).length) {
    return;
  }

  set(contactsLoadingAtom, true);

  try {
    const contacts = await contactApi.fetchContacts();

    set(
      contactsAtom,
      contacts.filter((contact) => contact.displayName),
    );
  } catch {
    // The picker stays on what it had; saving is what reports a server that is
    // not answering.
  } finally {
    set(contactsLoadingAtom, false);
  }
});
